import './Home.css';
import { FiMapPin, FiUser } from 'react-icons/fi';
import ShopPlanBadge from '../ShopPlanBadge';

const HomeTitle = ({ shopBranchName, nameUser, lastnameUser, username, shopPlanInfo }) => {
    const displayName = [nameUser, lastnameUser].filter(Boolean).join(' ');

    return (
        <div className="homeTitleContainer">
            <h1 className="homeTitle">
                Bienvenido a <span className="homeTitleAccent">QReate</span>
            </h1>
            <p className="homeTitleSub">Panel de acceso rápido a tu negocio</p>

            <div className="home-meta-row">
                <span className="home-meta-pill">
                    <FiMapPin size={15} aria-hidden />
                    <span><strong>Sucursal:</strong> {shopBranchName}</span>
                </span>
                <span className="home-meta-pill">
                    <FiUser size={15} aria-hidden />
                    <span>
                        <strong>{displayName}</strong>
                        {username ? ` · ${username}` : ''}
                    </span>
                </span>
                {shopPlanInfo?.shopPlanDisplayName ? (
                    <ShopPlanBadge
                        shopPlan={shopPlanInfo.shopPlan}
                        shopPlanDisplayName={shopPlanInfo.shopPlanDisplayName}
                        variant="pill"
                    />
                ) : null}
            </div>
        </div>
    );
};

export default HomeTitle;
